import React from 'react';

/**
 * InlineMessage — renders a contextual message bar. Renders nothing when message is null.
 *
 * Props:
 *   type      — 'error' | 'success' | 'warning' | 'info'
 *   message   — string | null
 *   onDismiss — optional callback for the × button
 *   style     — optional additional styles on the wrapper
 */
const STYLES = {
  error: {
    background: '#FFEBEE',
    border: '1px solid #FFCDD2',
    color: '#C62828',
    icon: '✕',
  },
  success: {
    background: '#E8F5E9',
    border: '1px solid #C8E6C9',
    color: '#2E7D32',
    icon: '✓',
  },
  warning: {
    background: '#FFF8E1',
    border: '1px solid #FFE082',
    color: '#9A5F00',
    icon: '⚠',
  },
  info: {
    background: '#E3F2FD',
    border: '1px solid #BBDEFB',
    color: '#1565C0',
    icon: 'ℹ',
  },
};

export default function InlineMessage({ type = 'error', message, onDismiss, style = {} }) {
  if (!message) return null;

  const s = STYLES[type] || STYLES.error;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '10px',
      padding: '10px 14px',
      borderRadius: '8px',
      fontSize: '13px',
      fontWeight: 500,
      lineHeight: 1.45,
      background: s.background,
      border: s.border,
      color: s.color,
      marginBottom: '12px',
      ...style,
    }}>
      <span style={{ flexShrink: 0, fontWeight: 700, fontSize: '14px', marginTop: '1px' }}>
        {s.icon}
      </span>
      <span style={{ flex: 1 }}>{message}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: s.color,
            opacity: 0.6,
            fontSize: '16px',
            lineHeight: 1,
            padding: '0 2px',
            flexShrink: 0,
          }}
          aria-label="Dismiss"
        >×</button>
      )}
    </div>
  );
}